// extracted by mini-css-extract-plugin
module.exports = {"KareemLinks":"Kareem_KareemLinks__2gvDA","registerDiv":"Kareem_registerDiv__2HWHQ","col":"Kareem_col__145Cx"};